import {CreateInstance} from './config'
const usersAPI = CreateInstance('users')
export default usersAPI
